module.exports = ".video-fluid {\n  width: 100%;\n  height: auto; }\n"